<template>
  <div class="index">
    <van-loading size="40" vertical v-if="!errorMsg">加载中...</van-loading>
    <van-empty image="error" :description="errorMsg" v-else />
  </div>
</template>

<script>
import getUrlParams from '@/utils/url-params'

export default {
  data() {
    return {
      errorMsg: ''
    }
  },
  async created() {
    const encode = getUrlParams('encode')
    if (!encode) {
      this.errorMsg = '获取二维码失败'
    } else {
      try {
        this.$store.commit('setEncode', encode)
        await this.$store.dispatch('getEncodeInfo')
        console.log(this.$store.state.encodeInfo)

        if (this.$store.state.encodeInfo.isActive) {
          this.$router.replace('/activation-info')
        } else {
          this.$router.replace('/fill-vincode')
        }
      } catch (error) {
        console.log(error)
        this.errorMsg = error.message
      }
    }
  }
}
</script>

<style scoped lang="less">
.index {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
